<template>
    <div class="big_box">
        <div class=" " style="height:.3rem"></div>
        <div class="img_box title_center">
            <img src="../../../img/93.jpg" style="width:100%;height:100%"/>
        </div>
        <div class="title_center text_center">扫描二维码或截屏关注公众号</div>
        <div class="img_44 title_center cursor" @click="$emit('close')"></div>
    </div>
</template>

<script>

module.exports = {
    data() {
        return {
        }
    },

}
</script>

<style scoped>
.text_center{
    text-align: center;
    font-size: 0.2rem;
}
.img_box{
    height: 1.60rem;
    width: 1.60rem;
}

</style>